import { Component, OnInit, NgZone,ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../services/api/api.service';
import { ToastService } from '../services/toast/toast.service';
import { Router } from '@angular/router';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { NativeGeocoder, NativeGeocoderResult, NativeGeocoderOptions } from '@ionic-native/native-geocoder/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx'; 
import { Platform,AlertController } from '@ionic/angular';
import { AlertService } from '../services/alert/alert.service';
import { LoaderService } from '../services/loader/loader.service';
import { environment } from '../../environments/environment';
declare var google: any;


@Component({
  selector: 'app-my-addresses',
  templateUrl: './my-addresses.page.html',
  styleUrls: ['./my-addresses.page.scss'],
})
export class MyAddressesPage implements OnInit {
  @ViewChild('map',  {static: false}) mapElement: ElementRef;
  options : any;
  currentPos : any;
  map: any;

  address:string;
  lat: string;
  long: string;  
  autocomplete: { input: string; };
  autocompleteItems: any[];
  location: any;
  placeid: any;
  GoogleAutocomplete: any;
  savedAddressCount:any = 0
  savedAddressList:any = []
  deviceToken:any = ''
  showAddress:any = true

  zipCodes: any = []

  data:any = {
    full_name: '',
    phone_no: '',
    alter_phone_no: '',
    address_line1: '',
    address_line2: '',
    landmark: '',
    city: '',
    country: environment.countryName,
    state: environment.stateName,
    pincode: '',
    google_address: '',
    lat: '',
    lon: '',
    zip_code: '',
    email: ''
  }
  showList:any = false
  isEdit:any = false
  currentLocDisable:any = true
  data_err:any = {
    full_name: false,
    phone_no: false,
    alter_phone_no: false,
    address_line1: false,
    address_line2: false,
    pincode: false,
    google_address: false,
    zip_code: false,
    city: false,
    email: false,
    country: false,
    state: false,
  }

  locationCoords: any;
  timetest: any;
  isWeb:any = false
  constructor(public api: ApiService,
    private router: Router,
    private platform: Platform,
    public toast: ToastService,
    private androidPermissions: AndroidPermissions,
    private geolocation: Geolocation,
    private locationAccuracy: LocationAccuracy,
    private nativeGeocoder: NativeGeocoder,
    public zone: NgZone,
    public alertController: AlertController,
    public alert: AlertService,
    public loader: LoaderService
    ) {
    this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
    this.autocomplete = { input: '' };
    this.autocompleteItems = [];
    this.locationCoords = {
      latitude: "",
      longitude: "",
      accuracy: "",
      timestamp: ""
    }
    this.timetest = Date.now();
   }

  ngOnInit() {
    this.getAddressData()
  }

  ionViewWillEnter(){
    let temp:any = localStorage.getItem("from-ship-page")
    if(temp != null && temp != "null" && temp != undefined && temp != ''){
        if(JSON.parse(temp) == true){
          this.addNewAddress()
        }
      }
    }

  getAddressData(){
    this.zone.run(() => {
      try {  
        this.api.getAddressList().subscribe((result:any) => {
          if(result.status == true){
            if(result.data.length > 0){
              this.savedAddressList = []
              this.savedAddressList = result.data;
              this.savedAddressCount = result.data.length;
            }
            else{
              this.savedAddressList = []
            }
          }
        },(err)=>{
          console.log(err)
        });
      }
      catch (error) {
        console.error('Here is the error message', error);
      }
   })
  }

  addMap(lat:any,long:any){
    this.loader.hideLoader()
    let latLng = new google.maps.LatLng(lat, long);
    let mapOptions = {
    center: latLng,
    zoom: 15,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    streetViewControl: false,
    // disableDefaultUI: true
    }
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    if(this.isWeb){
      this.map.addListener('dragend', () => {

        this.data.lat = this.map.center.lat();
        this.data.lon = this.map.center.lng();
  
        this.getAddressFromCoords(this.map.center.lat(), this.map.center.lng())
      });
    }
    else{
      this.addMarker();
    }
  }

  addMarker(){
    this.loader.hideLoader()
    let marker = new google.maps.Marker({
    map: this.map,
    animation: google.maps.Animation.DROP,
    position: this.map.getCenter()
    });

    let content = "<p>This is your current position !</p>";          
    let infoWindow = new google.maps.InfoWindow({
    content: content
    });

    google.maps.event.addListener(marker, 'click', () => {
    infoWindow.open(this.map, marker);
    });

}

  getAllZipCodes(){
    this.api.getZipCodes().subscribe((result:any) => {
      if(result.status == true){
        this.loader.hideLoader()
        this.zipCodes = []
        if(result.data.length > 0){
          this.zipCodes = result.data
        }
        else{
          this.zipCodes = []
        }
      }
    },(err)=>{
      this.loader.hideLoader()
      this.zipCodes = []
      console.log(err)
    });
  }

  //LOADING THE MAP HAS 2 PARTS.
  loadMap() {
    this.options = {
      enableHighAccuracy : true,
      timeout: 15000,
      maximumAge: 0
    };
    //FIRST GET THE LOCATION FROM THE DEVICE.
    this.loader.showLoader('Getting Current Location..')
    try {
      setTimeout(()=>{
        this.loader.hideLoader()
        // this.getAllZipCodes()
      },15000)
      this.geolocation.getCurrentPosition(this.options).then((resp:any) => {
        let latLng = new google.maps.LatLng(resp.coords.latitude, resp.coords.longitude);
        console.log(resp.coords.latitude,resp.coords.longitude)
        this.loader.hideLoader()
        this.addMap(resp.coords.latitude,resp.coords.longitude)
        this.data.lat = resp.coords.latitude;
        this.data.lon = resp.coords.longitude;
        // this.getAllZipCodes()
        //LOAD THE MAP WITH THE PREVIOUS VALUES AS PARAMETERS.
        this.getAddressFromCoords(resp.coords.latitude, resp.coords.longitude); 
  
      }).catch(async(error) => {
        await this.loader.hideLoader()
        console.log('Error getting location', error);
        // this.getAllZipCodes()
      });
    }
    catch (error) {
      this.loader.hideLoader()
      // this.getAllZipCodes()
    }
  }

    getAddressFromCoords(lattitude, longitude) {
      this.loader.hideLoader()
      console.log("getAddressFromCoords "+lattitude+" "+longitude);
      let options: NativeGeocoderOptions = {
        useLocale: true,
        maxResults: 5    
      }; 
      this.nativeGeocoder.reverseGeocode(lattitude, longitude, options)
        .then((result: NativeGeocoderResult[]) => {
          this.address = "";
          if(result.length > 0){
              this.data.country = result[0].countryName || '';
              this.data.pincode = result[0].postalCode || '';
              this.data.state = result[0].administrativeArea || '';
              this.data.city = result[0].locality || '';
            }
          let responseAddress = [];
          for (let [key, value] of Object.entries(result[0])) {
            if(value.length>0)
            responseAddress.push(value); 
          }
          responseAddress.reverse();
          for (let value of responseAddress) {
            this.address += value+", ";
          }
          this.address = this.address.slice(0, -2);
          this.autocomplete.input = this.address;
        })
        .catch((error: any) =>{ 
          this.address = "Address Not Available!";
        }); 
    }
    
    //AUTOCOMPLETE, SIMPLY LOAD THE PLACE USING GOOGLE PREDICTIONS AND RETURNING THE ARRAY.
    UpdateSearchResults(){
      if (this.autocomplete.input == '') {
        this.autocompleteItems = [];
        return;
      }
      this.data_err.google_address = false
      this.GoogleAutocomplete.getPlacePredictions({ input: this.autocomplete.input },
      (predictions, status) => {
        this.autocompleteItems = [];
        this.zone.run(() => {
          predictions.forEach((prediction) => {
            this.autocompleteItems.push(prediction);
          });
          if(this.autocompleteItems.length > 0){
            this.showList = true
          }
        });
      });
    }
    
    //wE CALL THIS FROM EACH ITEM.
    SelectSearchResult(item:any) {
      ///WE CAN CONFIGURE MORE COMPLEX FUNCTIONS SUCH AS UPLOAD DATA TO FIRESTORE OR LINK IT TO SOMETHING
      console.log(item)
      this.showList = false      
      this.placeid = item.place_id
      this.autocomplete.input = item.description
      if(!this.isWeb){
        this.getLatLngFromAddress(item.description)
      }
    }

    getLatLngFromAddress(address:any){
      let options: NativeGeocoderOptions = {
        useLocale: true,
        maxResults: 5
    };
      this.nativeGeocoder.forwardGeocode(address, options).then((result: NativeGeocoderResult[]) => { 
        console.log('The coordinates are latitude=' + result[0].latitude + ' and longitude=' + result[0].longitude)
        this.data.lat = result[0].latitude;
        this.data.lng = result[0].longitude;
        this.addMap(this.data.lat,this.data.lng)
      }).catch((error: any) => console.log(error));
    }
    
    
    //lET'S BE CLEAN! THIS WILL JUST CLEAN THE LIST WHEN WE CLOSE THE SEARCH BAR.
    ClearAutocomplete(){
      this.autocompleteItems = []
      this.autocomplete.input = ''
    }
    
  deleteAddress(addressId:any){
    try {  
      this.api.deleteAddress(addressId).subscribe((result:any) => {
        if(result.status == true){
          this.isEdit = false
          this.toast.presentToast("Address Deleted Successfully")
          this.getAddressData()
        }
      },(err)=>{
        console.log(err)
      });
    }
    catch (error) {
      console.error('Here is the error message', error);
    }
  }

  callAlert(id:any){
    this.presentAlertConfirm("Remove Address","Are you sure you want to delete this address?",id)
  }

  goBack(){
    this.showAddress = !this.showAddress;
    this.isEdit = false
  }

  addressId:any = ''
  editAddress(index:any){
    this.isEdit = true
    this.showAddress = false;
    this.addressId = this.savedAddressList[index].id
    this.data = {
      full_name: this.savedAddressList[index].name,
      phone_no: this.savedAddressList[index].mobile_number,
      alter_phone_no: this.savedAddressList[index].alternate_mobile_number,
      address_line1: this.savedAddressList[index].house_no_building_name,
      address_line2: this.savedAddressList[index].road_name_area_colony,
      landmark: this.savedAddressList[index].landmark,
      city: this.savedAddressList[index].landmark,
      email: this.savedAddressList[index].email || '',
      country: this.savedAddressList[index].country || '',
      state: this.savedAddressList[index].state || '',
      pincode: this.savedAddressList[index].pincode,
      google_address: this.savedAddressList[index].google_address,
      lat: JSON.parse(this.savedAddressList[index].location_latitude),
      lon: JSON.parse(this.savedAddressList[index].location_longitude)
    }
    this.autocomplete.input = this.savedAddressList[index].google_address
  }

  addNewAddress(){
    this.data = {
      full_name: '',
      phone_no: '',
      alter_phone_no: '',
      address_line1: '',
      address_line2: '',
      landmark: '',
      city: '',
      email:'',
      country: environment.countryName,
      state: environment.stateName,
      pincode: '',
      google_address: '',
      lat: '',
      lon: '',
      zip_code: ''
    }
    this.showAddress = false;
    // this.loadMap();
    this.platform.ready().then(() => {
      if (this.platform.is('hybrid')) {

        this.checkGPSPermission()
      }
      else {
        this.isWeb = true
        this.loadMap()
      }
    })
  }

  async saveAddress(){
    
    if(this.data.full_name.trim() == ''){
      this.data_err.full_name = true
      return
    }

    if(this.data.phone_no.trim() == ''){
      this.data_err.phone_no = true
      return
    }
    else if(this.data.phone_no.trim().length != 10){
      this.data_err.phone_no = true
      return
    }

    if(this.isWeb){
      if(typeof(JSON.parse(this.data.phone_no)) != "number"){
        this.data_err.phone_no = true
        return
      }
    }

    if(this.data.alter_phone_no.trim().length != 0){
      if(this.data.alter_phone_no.trim().length != 10){
        this.data_err.alter_phone_no = true
        return
      }

      if(this.isWeb){
        if(typeof(JSON.parse(this.data.alter_phone_no)) != "number"){
          this.data_err.alter_phone_no = true
          return
        }
      }
    }

    if(!this.validateEmail(this.data.email)){
      this.data_err.email = true
      return
    }

    if(this.data.address_line1.trim() == ''){
      this.data_err.address_line1 = true
      return
    }

    // if(this.data.address_line2.trim() == ''){
    //   this.data_err.address_line2 = true
    //   return
    // }

    if(this.data.city.trim() == ''){
      this.data_err.city = true
      return
    }

    if(this.data.email.trim() == ''){
      this.data_err.email = true
      return
    }



    if(this.data.pincode.trim() == ''){
      this.data_err.pincode = true
      return
    }

    // if(this.data.zip_code == ''){
    //   this.data_err.zip_code = true
    //   return
    // }

    if(this.data.state.trim() == ''){
      this.data_err.state = true
      return
    }

    if(this.data.country.trim() == ''){
        this.data_err.country = true
        return
    }

    this.data.google_address = this.autocomplete.input

    if(!this.isWeb){
      if(this.data.google_address.trim() == '' || this.data.google_address == undefined || this.data.google_address == null || this.data.google_address == 'null'){
        this.data_err.google_address = true
        await this.checkGPSPermission()
        // this.alert.presentAlert('Alert','','Please enable the location in your mobile')
        return
      }
    }

    let reqData:any = {
      "device_token": localStorage.getItem("uuid"),
      "name": this.data.full_name,
      "mobile_number": this.data.phone_no,
      "alternate_mobile_number": this.data.alter_phone_no,
      "house_no_building_name": this.data.address_line1,
      "road_name_area_colony": this.data.address_line2,
      "city": this.data.city,
      "email": this.data.email,
      "state": this.data.state,
      "pincode": this.data.pincode,
      "zip_code": this.data.zip_code || '',
      "landmark": this.data.city,
      "google_address": this.data.google_address,
      "location_latitude": JSON.parse(this.data.lat),
      "location_longitude": JSON.parse(this.data.lon),
      "country": this.data.country
      }

    if(this.isEdit == false){
      try {  
        this.api.addDeliveryAddress(reqData).subscribe((result:any) => {
          if(result.status == true){
            let temp:any = localStorage.getItem("from-ship-page")
            if(temp != null && temp != "null" && temp != undefined && temp != ''){
                if(JSON.parse(temp) == true){
                  localStorage.setItem("from-ship-page","null")
                  this.router.navigate(['/shipping',JSON.parse(localStorage.getItem("priceDetails"))]);
                }
              }
              else{
                this.toast.presentToast("Address Added Successfully")
                this.showAddress = !this.showAddress
                this.getAddressData()
              }
          }
        },(err)=>{
          console.log(err)
        });
      }
      catch (error) {
        console.error('Here is the error message', error);
      }
    }
    else{
      try {  
        this.api.updateAddress(this.addressId,reqData).subscribe((result:any) => {
          if(result.status == true){
            this.isEdit = false
            this.toast.presentToast("Address Updated Successfully")
            this.showAddress = !this.showAddress
            this.getAddressData()
          }
        },(err)=>{
          console.log(err)
        });
      }
      catch (error) {
        console.error('Here is the error message', error);
      }
    }

    
  }

  OnChange(value:any){
    if(value == 'name'){
      this.data_err.full_name = false
    }
    else if(value == 'phno'){
      this.data_err.phone_no = false
    }
    else if(value == 'al_phno'){
      this.data_err.alter_phone_no = false
    }
    else if(value == 'address_one'){
      this.data_err.address_line1 = false
    }
    else if(value == 'address_two'){
      this.data_err.address_line2 = false
    }
    else if(value == 'pincode'){
      this.data_err.pincode = false
    }
    else if(value == 'zip_code'){
      this.data_err.zip_code = false
    }
    else if(value == 'city'){
      this.data_err.city = false
    }
    else if(value == 'email'){
      this.data_err.email = false
    }
    else if(value == 'state'){
      this.data_err.state = false
    }
    else if(value == 'country'){
        this.data_err.country = false
      }
  }

  validateEmail(email:any) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  async presentAlertConfirm(header:any,message:any,id:any) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: header,
      message: message,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Okay',
          handler: () => {
            this.deleteAddress(id)
          }
        }
      ]
    });

    await alert.present();
  }

  ngOnDestroy() {
    localStorage.setItem("from-ship-page","null")
  }


  //Check if application having GPS access permission  
  checkGPSPermission() {
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION).then(
      result => {
        if (result.hasPermission) {

          //If having permission show 'Turn On GPS' dialogue
          this.askToTurnOnGPS();
        } else {

          //If not having permission ask for permission
          this.requestGPSPermission();
        }
      },
      err => {
        alert(err);
      }
    );
  }

  requestGPSPermission() {
    this.locationAccuracy.canRequest().then((canRequest: boolean) => {
      if (canRequest) {
        console.log("4");
      } else {
        //Show 'GPS Permission Request' dialogue
        this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION)
          .then(
            () => {
              // call method to turn on GPS
              this.askToTurnOnGPS();
            },
            error => {
              //Show alert if user click on 'No Thanks'
              this.requestGPSPermission();
              // alert('requestPermission Error requesting location permissions ' + error)
            }
          );
      }
    });
  }


  askToTurnOnGPS() {
    this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
      () => {
        // When GPS Turned ON call method to get Accurate location coordinates
        this.loadMap()
      },
      (error:any) =>{
        this.askToTurnOnGPS()
        // alert('Error requesting location permissions ' + JSON.stringify(error)
      })
  }



}
